// Current token key
export const ADMIN_TOKEN_KEY = 'ADMIN_TOKEN';

// Legacy token key that needs to be migrated
export const LEGACY_ADMIN_TOKEN_KEY = 'begigAdminAuthToken';

// Token expiration time in milliseconds (24 hours)
export const TOKEN_EXPIRATION_TIME = 24 * 60 * 60 * 1000; 